import React from 'react'

export default function HTMLFooterTemplate(props) {
    const pageSettings = {
        'a4': {
            'width': 794,
            'height': 1123
        },
        'letter': {
            'width': 595,
            'height': 842
        }
    };

    const renderElements = (section) => {
        return (
            props.properties &&
            props.properties[section]?.elements &&
            Object.keys(props.properties[section].elements).map((key) => {
                var data = props.properties[section].elements[key];
                if (!data) return null;

                var font = props.properties[section]?.font || { fontFamily: 'Inter', fontSize: 10, color: '#000000' }
                var dStyle = Object.assign({}, data.style || {});
                dStyle.color = dStyle.color || props.properties.prop.fontColor;
                dStyle.fontSize = dStyle.fontSize || props.properties.prop.fontSize + "pt";
                dStyle.left = dStyle.left ? parseInt(dStyle.left) * 0.75 : 0;
                dStyle.zIndex = 2;

                const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || `element-${key}`);

                return (
                    <div
                        key={data.id || key}
                        style={Object.assign(dStyle, font)}
                        id={data.id}
                        data-element={data.name || 'element'}
                        data-section={section}
                        data-path="elements"
                        data-index={dataIndex}
                    >
                        {data.text || ''}
                    </div>
                );
            })
        );
    };

    const renderShapes = () => {
        if (!props.properties.foot.shapes) return null;

        return Object.keys(props.properties.foot.shapes)
            .filter(s => s !== 'border')
            .map((key) => {
                var prop = props.properties.foot.shapes[key];
                if (!prop) return null;

                var borderColor = props.properties.foot.shapes.border?.color || '#333333FF';
                var borderSize = props.properties.foot.shapes.border?.size || 1;
                var bgColor = props.properties.foot.shapes.border?.fillColor || '#FFFFFFFF';

                var dStyle = Object.assign({ minWidth: '32px', minHeight: '16px' }, prop.style || {});
                dStyle.border = `${borderSize}px solid ${borderColor}`;
                dStyle.background = bgColor;
                dStyle.left = dStyle.left ? parseInt(dStyle.left) * 0.75 : 0;
                dStyle.width = dStyle.width ? parseInt(dStyle.width) * 0.75 : 32;
                dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;
                dStyle.zIndex = 1;

                return (
                    <div
                        key={key}
                        style={dStyle}
                        id={prop.id}
                        data-element={prop.name || 'shape'}
                        data-section={"foot"}
                        data-path="shapes"
                        data-index={prop.data || key}
                    />
                );
            });
    };

    return (
        <div style={{ width: '100%' }} className="foot">
            <div style={{
                height: props.properties.prop.orientation === "landscape"
                    ? props.heights.foot * 0.01 * pageSettings[props.properties.prop.paperSize]?.width
                    : props.heights.foot * 0.01 * pageSettings[props.properties.prop.paperSize]?.height,
                position: 'relative',
                backgroundColor: props.properties.foot.background.showColor
                    ? props.properties.foot.background.color
                    : "transparent",
            }}>
                <div>
                    {renderElements("foot")}
                    {renderShapes()}
                </div>
            </div>
        </div>
    );
}